import { useCallback } from 'react';

const useDisplayDate = () => {
  const formatDate = useCallback((dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  }, []);

  return { formatDate };
};

export default useDisplayDate;
